<template>
  <b-container fluid>
    <AdminDetail :config="config" />
    <BusinessRentings :business-id="$route.params.id" />
  </b-container>
</template>

<script>
import AdminDetail from "@/components/Global/AdminDetail";
import BusinessRentings from "@/components/Business/BusinessRentings";
import config from "./config";

export default {
  name: "BusinessDetail",
  components: {
    AdminDetail,
    BusinessRentings,
  },
  data() {
    return {
      config: config,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Business/BusinessDetail.vue